<template>
  <div class="input-container" :class="{ 'required-fail': requiredFail }">
    <textarea
      :value="value"
      @input="updateValue($event.target.value)"
      type="textarea"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import { inputTypeMixin } from "@/mixins/forms/dynamicObjectForms/inputTypeMixin";

export default {
  name: "InputTypeTextArea",

  mixins: [inputTypeMixin],
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/InputTypes/InputTypeTextArea.vue